<template>
  <div>
    <v-row>
      <v-col><canvas id="gender-chart"> </canvas></v-col>
      <v-col><canvas id="categories-chart"> </canvas></v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="8"> <canvas id="province-chart"> </canvas></v-col>
    </v-row>
    <br />
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import { codeColor } from "../store/codeColor";
import router from "../router";
import { authFirebase } from "../../firebase_instant";

export default {
  created() {
    authFirebase.auth().onAuthStateChanged((user) => {
      if (!user) {
        router.push({ name: "userLogin" });
      }
    });
  },

  mounted() {
    this.fetchDataFromServer;
  },

  methods: {
    genderChart() {
      let ctx = document.getElementById("gender-chart");
      new Chart(ctx, {
        type: "pie",
        data: {
          labels: this.fetchDataFromState_Gender["keysGender"],
          datasets: [
            {
              label: "Page A",
              data: this.fetchDataFromState_Gender["valuesGender"],
              backgroundColor: ["#12bdb9", "#4444dd", "#ff6644"],
            },
          ],
        },
        options: {
          responsive: true,
          title: {
            display: true,
            text: "เพศ",
          },
          legend: {
            display: true,
            labels: {
              fontColor: "rgb(0, 0, 0)",
            },
          },
        },
      });
    },
    provinceChart() {
      let ctx = document.getElementById("province-chart");
      new Chart(ctx, {
        type: "pie",
        data: {
          labels: this.fetchDataFromState_Provinces["keysProvinces"],
          datasets: [
            {
              label: "Page A",
              data: this.fetchDataFromState_Provinces["valuesProvinces"],
              backgroundColor: this.codeColor,
            },
          ],
        },
        options: {
          responsive: true,
          title: {
            display: true,
            text: "จังหวัด",
          },
          legend: {
            display: false,
          },
        },
      });
    },
    categoriesChart() {
      let ctx = document.getElementById("categories-chart");
      new Chart(ctx, {
        type: "pie",
        data: {
          labels: this.fetchDataFromState_Categories["keysCategories"],
          datasets: [
            {
              label: "Page A",
              data: this.fetchDataFromState_Categories["valuesCategories"],
              backgroundColor: [
                "#a8ddb5 ",
                "#7bccc4",
                "#4eb3d3",
                "#2b8cbe",
                "#0868ac",
                "#084081",
              ],
            },
          ],
        },
        options: {
          responsive: true,
          title: {
            display: true,
            text: "สินค้าที่ชอบ",
          },
        },
      });
    },
    logout() {
      authFirebase
        .auth()
        .signOut()
        .then(() => {
          router.push({ name: "form" });
        });
    },
  },
  computed: {
    fetchDataFromServer() {
      return this.$store.dispatch("fetchData");
    },
    fetchDataFromState_Gender() {
      return this.$store.getters["dataGenderFromState"];
    },
    fetchDataFromState_Categories() {
      return this.$store.getters["dataCategoriesFromState"];
    },
    fetchDataFromState_Provinces() {
      return this.$store.getters["dataProvinceFromState"];
    },
  },
  watch: {
    fetchDataFromState_Categories: function () {
      this.categoriesChart();
    },
    fetchDataFromState_Provinces: function () {
      this.provinceChart();
    },
    fetchDataFromState_Gender: function () {
      this.genderChart();
    },
  },
  data: () => ({
    codeColor,
    testGender: null,
  }),
};
</script>


